import React from 'react';
import { BookOpenIcon } from '@heroicons/react/24/outline';

const Literature = ({ items }) => (
  <ul className="space-y-4">
    {items.map((item, index) => (
      <li key={index} className="flex items-start">
        <BookOpenIcon className="h-6 w-6 text-blue-500 flex-shrink-0" />
        <span className="ml-3 text-gray-600">{item}</span>
      </li>
    ))}
  </ul>
);

export default Literature;
